import { EmployeeLiteModel } from 'api-hooks/employee';
import { Type } from 'class-transformer';

export class CommissionModel {
  id: string;
  amount: string;
  pax: number;
  total: string;

  @Type(() => EmployeeLiteModel)
  employee: EmployeeLiteModel;
}

export class getCommissionInput {
  id: string;
  params: {
    page: number;
    limit?: number;
    q?: string;
  };
}
